import React, { Component } from "react";

import { InputGroup } from "react-bootstrap";

import AgGridReactEx from "@app/components/AgGridReactEx";

export default class ContentBranchNurseryList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            tableData: null,
            keyword: null,
        };
        this.searchRef = React.createRef();
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState(
            {
                data: nextProps.data,
            },
            () => {
                this.setState({ tableData: this.listSearch(this.state.keyword) });
            }
        );
    };

    listColumn = [
        {
            headerName: "No",
            headerClass: "bg-dark text-light",
            field: "id",
            sortable: false,
            width: 70,
            resizable: true,
            cellClass: "text-center",
            filter: false,
            valueGetter: "node.rowIndex + 1",
        },
        {
            headerName: "원명",
            field: "nurseryName",
            sortable: true,
            minWidth: 140,
            headerClass: "bg-dark text-light",
            cellClass: "text-left",
            resizable: true,
            sort: "asc",
        },
        {
            headerName: "계약 반 수",
            field: "countClass",
            sortable: true,
            minWidth: 150,
            headerClass: "bg-dark text-light",
            cellClass: "text-center",
            cellRenderer: (param) => {
                return param.value ? param.value.toLocaleString() : "-";
            },
        },
        {
            headerName: "계약 원아 수",
            field: "contractChild",
            sortable: true,
            minWidth: 150,
            headerClass: "bg-dark text-light",
            cellClass: "text-center",
            cellRenderer: (param) => {
                return param.value ? param.value.toLocaleString() : "-";
            },
        },
        {
            headerName: "교실영어 실행 수",
            field: "playCountClass",
            sortable: true,
            minWidth: 180,
            headerClass: "bg-dark text-light",
            cellClass: "text-center",
            cellRenderer: (param) => {
                return param.value ? param.value.toLocaleString() : "-";
            },
        },
        {
            headerName: "스페셜 실행 수",
            field: "playCountSpecial",
            sortable: true,
            minWidth: 135,
            headerClass: "bg-dark text-light",
            cellClass: "text-center",
            cellRenderer: (param) => {
                return param.value ? param.value.toLocaleString() : "-";
            },
        },
    ];

    handleKeyPress = (e) => {
        if (e.key === "Enter") {
            this.searchData();
        }
    };

    searchData = () => {
        if (this.searchRef.current) {
            var keyword = this.searchRef.current.value;

            var tableData = this.listSearch(keyword);

            this.setState({
                tableData: tableData,
                keyword: keyword,
            });
        }
    };

    listSearch = (keyword) => {
        var list = this.state.data;
        var tableData = [];
        if (!keyword) {
            tableData = list;
        } else {
            if (list && list.length > 0) {
                list.map((item) => {
                    if (item.nurseryName && item.nurseryName.indexOf(keyword) >= 0) {
                        tableData.push(item);
                    }
                });
            }
        }
        return tableData;
    };

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.sizeColumnsToFit();
    };

    rowClick = (agGrid) => {
        // document.location.href = "/metrics/contract/branch?id=" + agGrid.api.selectionController.lastSelectedNode.data.id + "&year="+this.state.year;
        const selected = agGrid.api.selectionController.lastSelectedNode.data;
        if (selected && this.props.onRowClick) {
            this.props.onRowClick(selected.nurseryUniqId, selected.nurseryName);
        }
    };

    rowDataChanged = (params) => {
        this.setState({
            tableSummary: (this.state.tableData ? this.state.tableData.length.toLocaleString() : 0) + " / " + (this.state.data ? this.state.data.length.toLocaleString() : 0),
        });
    };

    onSortChanged = (params) => {
        const sortState = params.api.getSortModel();
        if (sortState.length == 0) {
            this.props.onListSortChanged(null, null);
        } else {
            if (this.props.onListSortChanged) {
                this.props.onListSortChanged(sortState[0].colId, sortState[0].sort);
            }
        }
    };

    render() {
        if (this.state.tableData == null) {
            return (
                <>
                    <div
                        style={{
                            height: this.props.height + "px",
                            textAlign: "center",
                            paddingTop: `${this.props.height / 2 - 80}px`,
                        }}
                    >
                        <span className="dashboard-spinner spinner-xxl"></span>
                    </div>
                </>
            );
        } else {
            return (
                <>
                    <div className="row justify-content-end">
                        <div className="col-xl-8 col-lg-8 col-md-6 col-sm-12 col-12 pl-4 d-flex">
                            <h5 className="mb-0" style={{ alignSelf: "end" }}>
                                <span>
                                    {this.state.tableData ? this.state.tableData.length.toLocaleString() : "0"} / {this.state.data ? this.state.data.length.toLocaleString() : "0"}
                                </span>
                            </h5>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 mb-2 pr-3">
                            <InputGroup className="input-group my-group">
                                <input className="form-control" type="text" placeholder="원 검색" ref={this.searchRef} onKeyPress={this.handleKeyPress} />
                                <InputGroup.Append>
                                    <button type="button" className="btn btn-primary" onClick={this.searchData}>
                                        검색
                                    </button>
                                </InputGroup.Append>
                            </InputGroup>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <AgGridReactEx
                                columnDefs={this.listColumn}
                                rowData={this.state.tableData}
                                onGridReady={this.onGridReady}
                                onRowDataChanged={this.rowDataChanged}
                                onSortChanged={this.onSortChanged}
                                rowSelection="single"
                                onSelectionChanged={this.rowClick}
                                pagination={true}
                            />
                        </div>
                    </div>
                </>
            );
        }
    }
}
